<ol class="breadcrumb float-xl-right">
  <li class="breadcrumb-item">Inicio</li>
  <li class="breadcrumb-item active">Importar Movimientos</li>
</ol>

<h1 class="page-header"><i class="fas fa-file-import"></i> Importar Movimientos</h1>

<panel [noButton]="true">
  <div class="row mb-3">
    <div class="col-xxl-4 col-xl-5 col-lg-6 col-md-12">
      <label class="form-label fw-bold">Tipo de Movimiento</label>
      <select class="form-select" [(ngModel)]="selectedSheet">
        @for (s of sheets; track s) {
          <option [value]="s.index">{{ s.name }}</option>
        }
      </select>
    </div>
  </div>

  <div class="row">
    <div class="col-xxl-5 col-xl-6 col-lg-8 col-md-12">
      <div class="input-group">
        <input type="file" id="file" class="form-control" accept=".xlsx" (change)="fileChangeEvent($event)">
        <button type="button" class="btn btn-outline-primary" [disabled]="!fileName || loading" (click)="uploadFile()">
          <i class="fas fa-upload"></i> Importar
        </button>
        @if (fileName) {
          <button type="button" class="btn btn-outline-secondary" (click)="clearFile()">
            <i class="fas fa-times"></i>
          </button>
        }
      </div>
      @if (fileName) {
        <small class="text-muted">Archivo: {{ fileName }}</small>
      }
    </div>
  </div>
</panel>

@if (importResult) {
  <div>
    <panel [noButton]="true">
      <div class="row mb-2">
        <div class="col">
          <strong>Resultado:</strong>
          <span class="badge bg-success ms-2">{{ importResult.imported }} importados</span>
          @if (importResult.errors.length) {
            <span class="badge bg-danger ms-2">{{ importResult.errors.length }} errores</span>
          }
        </div>
      </div>
      @if (importResult.errors.length) {
        <div class="table-responsive">
          <table class="table table-sm table-bordered">
            <thead class="table-danger">
              <tr>
                <th>Fila</th>
                <th>Error</th>
              </tr>
            </thead>
            <tbody>
              @for (err of importResult.errors; track err) {
                <tr>
                  <td>{{ err.row }}</td>
                  <td>{{ err.message }}</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    </panel>
  </div>
}
